import { useContext, useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import { useTranslation } from "react-i18next";

import { toast } from "react-toastify";
import { RadioButton } from "primereact/radiobutton";
import {
	Button,
	Card,
	Col,
	OverlayTrigger,
	Row,
	Tooltip,
} from "react-bootstrap";

import { HiOutlineArrowCircleLeft } from "react-icons/hi";
import logo from "../../../../assets/img/logo.svg";
import { formatReal } from "../../../../helpers";
import useWindowDimensions from "../../../../hooks/useWindowDimensions";
import { getPlans } from "../../../services/plans.service";
import UsuarioContext from "../../../../context/userContext/context";
import { MdInfoOutline } from "react-icons/md";

export const Plans = (): JSX.Element => {
	const history = useHistory();
	const { width } = useWindowDimensions();
	const { user } = useContext(UsuarioContext);
	const { t: translation } = useTranslation();

	const [plans, setPlans] = useState<any[]>([]);
	const [planSelected, setPlanSelected] = useState<any>(null);

	useEffect(() => {
		getPlans().then((fetchedPlans: any) => {
			setPlans(fetchedPlans);
		});
	}, []);

	const onSelectPlan = (plan: any) => {
		if (plan.id === planSelected?.id) {
			setPlanSelected(null);
		} else {
			setPlanSelected(plan);
		}
	};

	const onBuy = () => {
		if (planSelected?.url_checkout) {
			window.open(planSelected?.url_checkout, "_blank");
		} else {
			toast.error(
				"Link de compra do plano indisponível. Tente novamente mais tarde."
			);
		}
	};

	return (
		<div className="div-plans">
			<Row>
				<Col xs={12} className="pl-0 mb-0">
					<img src={logo} alt="Logo" height={45} />
					<h2 className="text-black mt-3 mb-0">
						<OverlayTrigger
							placement={"top"}
							overlay={<Tooltip>Voltar</Tooltip>}
						>
							<span>
								<HiOutlineArrowCircleLeft
									size={28}
									style={{
										marginRight: "10px",
										marginBottom: "8px",
										cursor: "pointer",
									}}
									onClick={() => history.goBack()}
								/>
							</span>
						</OverlayTrigger>
						<b>{translation("plans.locationPlans")}</b>
					</h2>
				</Col>

				<Col lg={6} className="mb-4">
					<p className="text-dstore font-20 mt-5">
						{translation("plans.welcome")}
					</p>
					<p className="text-black font-22 font-500 mb-5">
						{translation("plans.planMessage")}
					</p>

					<p className="text-black font-20">
						{translation("plans.question")}
					</p>
					<Button
						variant="outline-primary"
						style={{ height: "50px" }}
						onClick={() =>
							window.open(
								"https://api.whatsapp.com/send/?phone=554891177086&text&app_absent=0",
								"_blank"
							)
						}
					>
						<b>{translation("plans.contact").toUpperCase()}</b>
					</Button>
				</Col>
				<Col lg={6} className="text-center">
					<div className="div-select-plan mb-3">
						{plans.map((plan: any) => (
							<Card
								key={plan.id}
								className={`mb-4 card-location-plans ${
									plan.id === planSelected?.id
										? "card-plan-selected"
										: ""
								}`}
								onClick={() => onSelectPlan(plan)}
							>
								<Card.Body>
									<Row>
										<Col
											xs={width < 600 ? 12 : 7}
											className="text-start"
										>
											<Row>
												<Col
													xs={2}
													className="d-flex justify-content-end align-items-center"
												>
													<RadioButton
														checked={
															plan.id ===
															planSelected?.id
																? true
																: false
														}
														onChange={() =>
															onSelectPlan(plan)
														}
													/>
												</Col>
												<Col xs={10}>
													<p className="text-black font-20 mb-1">
														<b>{plan.name}</b>
													</p>
													<p className="text-darker-grey mb-0">
														Até {plan.materials_max}{" "}
														disciplinas
													</p>
												</Col>
											</Row>
										</Col>
										<Col
											xs={width < 600 ? 12 : 5}
											className="text-end"
										>
											{width < 600 ? (
												<Row>
													<Col xs={2}></Col>
													<Col>
														<div className="d-flex justify-content-start align-items-center mt-3">
															<p className="mb-0 mr-2 text-black font-18">
																{plan.parcel_max
																	? plan.parcel_max +
																	  "x de"
																	: ""}
															</p>
															<p className="mb-0 text-black font-22">
																<b>
																	R${" "}
																	{formatReal(
																		plan.parcel
																	)}
																</b>
															</p>
														</div>
													</Col>
												</Row>
											) : (
												<>
													<p className="mb-0 text-black font-18">
														{plan.parcel_max
															? plan.parcel_max +
															  "x de"
															: ""}
													</p>
													<p className="mb-0 text-black font-22">
														<b>
															R${" "}
															{formatReal(
																plan.parcel
															)}
														</b>
													</p>
												</>
											)}
										</Col>
									</Row>
								</Card.Body>
							</Card>
						))}
					</div>

					<Button
						className="mb-2"
						style={{ width: "70%", height: "50px" }}
						onClick={() => onBuy()}
						disabled={
							user.profile_status === "Assinante" ||
							user.profile_status === "Parceiro"
								? true
								: planSelected !== null
								? false
								: true
						}
					>
						<b>{translation("plans.buy").toUpperCase()}</b>
					</Button>

					{user.token !== "" &&
						user.profile_status === "Parceiro" &&
						planSelected !== null && (
							<Row
								className="mt-2 px-4 text-start"
								style={{ fontSize: "18px", color: "#DD7B2A" }}
							>
								<Col xs={1}>
									<MdInfoOutline size="23" />
								</Col>
								<Col xs={11}>
									Você possui uma conta de parceiro. Crie uma
									nova conta para comprar um de nossos planos
									de locação.
								</Col>
							</Row>
						)}

					{user.token !== "" &&
						user.profile_status === "Assinante" &&
						planSelected !== null && (
							<Row
								className="mt-2 px-4 text-start"
								style={{ fontSize: "18px", color: "#DD7B2A" }}
							>
								<Col xs={1}>
									<MdInfoOutline size="23" />
								</Col>
								<Col xs={11}>
									Você já possui um plano. Fale com o consultor para fazer o upgrade do seu plano. 
									<a href="https://api.whatsapp.com/send/?phone=554891177086&text&app_absent=0">Entre em conta com um consultor</a>
								</Col>
							</Row>
						)}
				</Col>
			</Row>
		</div>
	);
};
